// extracted by mini-css-extract-plugin
export default {"cls1":"StyledComponents-FormItem_cls1__K1fS1","cls2":"StyledComponents-FormItem_cls2__LrVQ0 StyledComponents-FormItem_cls1__K1fS1"};